import React from 'react'
import { Badge, Whisper, Tooltip } from 'rsuite'
import { Cell } from 'rsuite-table'

type RowData = {
  [key: string]: string | boolean
}

type StatusCellProps = {
  rowData?: RowData
  dataKey: string
  posDataLabel?: string
  negDataLabel?: string
}

const defaultProps = {
  rowData: undefined
}

const activeLabels = ['Active', 'Live', true, 'Yes']

const activeStyle = {
  backgroundColor: '#ECFDF3',
  color: '#14BA6D',
  padding: '3px 10px 3px 5px',
  whiteSpace: 'nowrap' as const
}

const inactiveStyle = {
  backgroundColor: '#E9EDF5',
  color: '#6C778B',
  padding: '3px 10px 3px 5px',
  whiteSpace: 'nowrap' as const
}

const StatusCell: React.FC<StatusCellProps> = ({
  rowData,
  dataKey,
  posDataLabel,
  negDataLabel,
  ...props
}) => {
  const label = rowData?.[dataKey]
  const isActive = activeLabels.includes(label as string | boolean)
  const tooltipText = isActive
    ? posDataLabel ?? 'Active'
    : negDataLabel ?? String(label ?? '')

  return (
    <Whisper
      placement="bottom"
      trigger="hover"
      speaker={<Tooltip>{tooltipText}</Tooltip>}
    >
      <Cell {...props}>
        <Badge
          style={isActive ? activeStyle : inactiveStyle}
          content={
            <>
              <Badge
                style={
                  isActive
                    ? { backgroundColor: '#14BA6D', margin: '0 7px' }
                    : { backgroundColor: '#6C778B', margin: '0 7px' }
                }
              />
              {isActive ? posDataLabel : negDataLabel || label}
            </>
          }
        />
      </Cell>
    </Whisper>
  )
}

StatusCell.defaultProps = defaultProps

export default StatusCell
